import { ArrowRight, ChevronDown } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useFormPopup } from "@/components/FormPopupContext";

export default function HeroSection() {
  const { setOpen } = useFormPopup();

  return (
    <section
      id="hero"
      data-testid="hero-section"
      className="relative pt-32 pb-24 sm:pt-40 sm:pb-32 overflow-hidden"
      style={{ background: "linear-gradient(170deg, #F8FAFC 0%, #ECFDF5 50%, #F0FDF4 100%)" }}
    >
      <div className="absolute top-20 right-0 w-72 h-72 bg-emerald-200/20 rounded-full blur-2xl pointer-events-none" />
      <div className="absolute bottom-0 left-0 w-56 h-56 bg-emerald-100/30 rounded-full blur-2xl pointer-events-none" />

      <div className="max-w-7xl mx-auto px-6 sm:px-8 relative">
        <div className="max-w-3xl">
          <div className="inline-flex items-center gap-2 px-4 py-1.5 bg-emerald-50 border border-emerald-200 rounded-full mb-8 animate-fade-in-up">
            <span className="w-2 h-2 bg-emerald-500 rounded-full animate-pulse" />
            <span className="text-xs font-semibold text-emerald-700 tracking-wide uppercase">
              Intermediario financiero regulado
            </span>
          </div>

          <h1
            data-testid="hero-headline"
            className="text-4xl sm:text-5xl lg:text-6xl font-semibold tracking-tighter text-slate-900 leading-[1.08] animate-fade-in-up animation-delay-100"
            style={{ fontFamily: 'Outfit, sans-serif' }}
          >
            Solicita tu credito online de forma{" "}
            <span className="text-emerald-600">simple y segura</span>
          </h1>

          <p
            data-testid="hero-subheadline"
            className="mt-6 text-base sm:text-lg text-slate-600 leading-relaxed max-w-xl animate-fade-in-up animation-delay-200"
          >
            Compara opciones desde $500.000 CLP con entidades financieras confiables. 
            Proceso 100% online, seguro y confidencial.
          </p>

          <div className="mt-10 flex flex-col sm:flex-row gap-4 animate-fade-in-up animation-delay-300">
            <Button
              data-testid="hero-cta-simular"
              onClick={() => setOpen(true)}
              className="bg-emerald-500 hover:bg-emerald-600 text-white font-medium rounded-xl px-8 h-12 text-base shadow-lg shadow-emerald-500/25 hover:shadow-xl hover:shadow-emerald-500/30 transition-all duration-200 active:scale-95"
            >
              Simular credito
              <ArrowRight className="w-4 h-4 ml-1" />
            </Button>
            <a href="#como-funciona">
              <Button
                data-testid="hero-cta-como-funciona"
                variant="outline"
                className="border-2 border-slate-200 hover:border-slate-900 text-slate-900 font-medium rounded-xl px-8 h-12 text-base transition-all duration-200"
              >
                Como funciona
                <ChevronDown className="w-4 h-4 ml-1" />
              </Button>
            </a>
          </div>

          <p className="mt-6 text-xs text-slate-400 animate-fade-in-up animation-delay-400">
            La aprobacion del credito esta sujeta a evaluacion crediticia.
          </p>
        </div>
      </div>
    </section>
  );
}
